export enum MeetingScheduleType {
    Instant = 1,
    Scheduled = 2,
}

export const MeetingScheduleTypesOptions = {
    [MeetingScheduleType.Instant]: 'Instant',
    [MeetingScheduleType.Scheduled]: 'Scheduled',
};
